import { render, staticRenderFns } from "./FeedParticipants.vue?vue&type=template&id=f71d0ed4&"
import script from "./FeedParticipants.vue?vue&type=script&lang=ts&"
export * from "./FeedParticipants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports